import { ModerationDashScreen, ModerationDashStructure } from 'structure/moderation-dash';
import { CLICK, component, componentWithVariants, demoFile, INPUT, story, variant } from 'system/demo';
import { t } from 'util/stdtypes';

demoFile('structure/moderationdash');

const modulePublic = {
    moderation: {
        queue: {
            a: { text: 'Awaiting Judgement', structureKey: 'question', instanceKey: 'bla' },
            b: { text: 'Rejected', judgement: 'reject' },
            c: { text: 'Also awaiting Judgement' },
        },
    },
};

componentWithVariants('ModerationDashScreen', ModerationDashScreen, {}, [
    variant(
        null,
        {
            config: ModerationDashStructure.receivesConfigDefaults,
            state: {
                roles: ['Moderator'],
                modulePublic,
                serverCall: {
                    moderation: {
                        getModItemAuthors: async () => {
                            return {
                                a: { authorName: 'Dick Dastardly', from: 'd' },
                                b: { authorName: 'Big Bill Brown', from: 'b' },
                                c: { authorName: 'Cruela Deville', from: 'c' },
                            };
                        },
                    },
                },
            },
        },
        [
            story('Reject Item', [CLICK('a'), INPUT('explanation', 'Your comment sucked'), CLICK('Reject')]),
            story('Approve Item', [CLICK('c'), CLICK('Approve')]),
        ],
    ),

    variant(
        'Transparency Dashboard',
        {
            config: ModerationDashStructure.receivesConfigDefaults,
            state: { modulePublic },
        },
        [story('Change filter', [CLICK('Rejected')])],
    ),
]);
